<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <div class="flex justify-between">
              <h2 class="text-xl font-semibold" v-if="count_list">
                Total -
                <span v-if="count_list">{{ count_list }}</span>
                <span v-else>Null</span>
              </h2>
              <router-link :to="{ name: 'HodDashboards' }">
                <button class="bg-blues text-white py-1 px-3 rounded-lg">
                  Back
                </button>
              </router-link>
            </div>
            <div class="flex">
              <form
                @submit.prevent="searchUserValue"
                class="flex w-full md:w-auto"
              >
                <input
                  type="text"
                  placeholder="Search here"
                  v-model="searching"
                  @input="searchUserValue"
                  class="px-4 py-2 rounded-l-md border border-gray-300 focus:outline-none"
                />
                <button class="bg-blue-900 text-white px-4 py-2 rounded-r-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </form>
            </div>

            <!-- <div class="flex justify-between">
              <h1 class="text-lg font-semibold dark_text">Details</h1>
            </div> -->

            <div class="text-[#0085DB] font-bold">
              <ul class="breadcrumb flex flex-wrap">
                <li
                  v-for="(item, index) in b_value"
                  :key="index"
                  :class="{
                    'breadcrumb-item': !isActive(index),
                    'active-breadcrumb-item': isActive(index),
                  }"
                >
                  <span
                    class="pl-2 text-sm"
                    :class="{ 'breadcrumb-text': !isActive(index) }"
                  >
                    <router-link :to="{ name: item.name }">{{
                      item.text
                    }}</router-link>
                  </span>
                  <span
                    v-if="index < b_value.length - 1"
                    class="breadcrumb-arrow"
                  >
                    &gt;
                  </span>
                </li>
              </ul>
            </div>

            <div class="w-full overflow-scroll">
              <table class="min-w-full">
                <thead>
                  <tr
                    class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                  >
                    <th class="px-6 py-3">S.No</th>
                    <th class="px-6 py-3">Email</th>
                    <th class="px-6 py-3">Display name</th>
                    <th class="px-6 py-3">Permission</th>
                    <th class="px-6 py-3">is_Active</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
                  <tr class="w-full">
                    <td colspan="12" class="text-center py-6">
                      <div class="flex items-center justify-center">
                        <img src="@/assets/attendance/loading.gif" alt="" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <template v-if="departments.length > 0">
                    <tr
                      v-for="(list, index) in departments"
                      :key="index"
                      class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
                    >
                      <td class="px-6 py-3">
                        {{ (currentPage - 1) * perPage + index + 1 }}
                      </td>

                      <td class="px-6 py-3">
                        <span v-if="list.email != null">{{ list.email }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.display_name != null">{{
                          list.display_name
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.permission != null">{{
                          list.permission
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <!-- <td class="px-6 py-3">
                        <span v-if="list.is_active != null">{{
                          list.is_active
                        }}</span
                        ><span v-else>---</span>
                      </td> -->
                      <td class="px-6 py-3">
                        <label
                          class="relative inline-block w-12 h-7 sm:w-10 sm:h-5"
                        >
                          <input
                            type="checkbox"
                            class="peer opacity-0 w-0 h-0"
                            :checked="list.is_active"
                            @change="handleToggle(list)"
                          />
                          <!-- Track -->
                          <span
                            :class="[
                              'absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition duration-300',
                              list.is_active ? 'bg-green-400' : 'bg-red-500',
                            ]"
                          ></span>

                          <!-- Knob -->
                          <span
                            :class="[
                              'absolute border border-white rounded-full transition duration-300',
                              'bottom-[5px] left-[4px] h-5 w-5 sm:h-[15px] sm:w-[15px] sm:bottom-[2.5px] sm:left-[2px]',
                              list.is_active
                                ? 'translate-x-[22px] sm:translate-x-[18px] bg-green-600'
                                : 'translate-x-0 bg-white',
                            ]"
                          ></span>
                        </label>

                        <!-- Popup -->
                        <div
                          v-if="showPopup"
                          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
                        >
                          <div
                            class="lg:w-[40%] 2xl:w-[30%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
                          >
                            <div
                              class="w-full flex flex-col relative rounded-2xl"
                            >
                              <div class="w-full flex flex-col gap-8">
                                <h1
                                  v-if="this.checkbox_status == false"
                                  class="font-bold text-sm text-red-400 text-center"
                                >
                                  Do You Want To Deactivate This User
                                  <span class="text-sm text-blues">{{
                                    dep_email
                                  }}</span
                                  >?
                                </h1>
                                <h1
                                  v-else
                                  class="font-bold text-sm text-green-400 text-center"
                                >
                                  Do You Want To Activate This User
                                  <span class="text-sm text-blues">{{
                                    dep_email
                                  }}</span
                                  >?
                                </h1>
                                <div
                                  class="flex items-center justify-center gap-5"
                                >
                                  <button
                                    @click="cancelToggle"
                                    class="bg-blues text-white rounded-xl text-sm font-semibold px-6 py-2"
                                  >
                                    No
                                  </button>
                                  <button
                                    @click="confirmToggle"
                                    class="bg-blues text-white rounded-xl text-sm font-semibold px-6 py-2"
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="11" class="px-6 py-3 text-center">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
                <!-- <tfoot>
                  <tr>
                    <td colspan="11" class="p-6 bg-[#18469d]"></td>
                  </tr>
                </tfoot> -->
                <tfoot v-if="totalPages > 1" class="">
                  <tr>
                    <td colspan="7" class="bg-[#18469d]">
                      <div class="flex justify-center py-4 space-x-2">
                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage === 1"
                          @click="prevPage"
                        >
                          &laquo;
                        </button>

                        <button
                          v-for="page in paginationRange"
                          :key="page"
                          class="px-3 py-2 rounded"
                          :class="{
                            'bg-blue-500 text-white': currentPage === page,
                            'bg-white border border-gray-400 text-gray-800':
                              currentPage !== page,
                          }"
                          @click="changePage(page)"
                        >
                          {{ page }}
                        </button>

                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage >= totalPages"
                          @click="nextPage"
                        >
                          &raquo;
                        </button>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Hod/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //   loading: true,
      messages: {
        text: "",
        type: "null",
      },
      selectsemester: "",
      selectPatch: "",
      selectdepartment: "",
      selectprogram: "",
      selectsession: "",
      selectsection: "",
      departments: [],

      count_list: "",
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      searching: "",
      b_value: [],
      showPopup: false,
      pendingItem: null,
      dep_email: "",
      checkbox_status: false,
    };
  },
  props: ["depart_id", "d_name"],
  components: {
    SideBar,
    FlashMessage,
  },
  async created() {
    this.b_value = [
      { text: "Dashboard", name: "HodDashboards" },
      { text: "Department", name: "HodDashboards" },
      { text: this.d_name },
    ];
    await this.departmentget();
  },

  computed: {
    ...mapGetters(["userInfo"]),
    paginationRange() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      let pages = [];

      if (totalPages <= 5) {
        pages = [...Array(totalPages).keys()].map((x) => x + 1);
      } else {
        if (currentPage > 3) pages.push(1);
        if (currentPage > 4) pages.push("...");

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (currentPage < totalPages - 3) pages.push("...");
        if (currentPage < totalPages - 2) pages.push(totalPages);
      }

      return pages;
    },
  },
  methods: {
    handleToggle(item) {
      if (item) {
        this.pendingItem = item;
        this.dep_email = item.email;
        this.showPopup = true;
        if (item.is_active == true) {
          this.checkbox_status = false;
        } else {
          this.checkbox_status = true;
        }
      }
    },
    cancelToggle() {
      this.pendingItem = null;
      this.showPopup = false;
    },
    confirmToggle() {
      if (this.pendingItem) {
        this.updateStatus(this.pendingItem, false);
        this.pendingItem = null;
        this.showPopup = false;
      }
    },

    async updateStatus(item) {
      console.log("item1111", item.is_active);
      let acceptsVal = {};
      if (item.is_active == true) {
        acceptsVal = {
          is_active: false,
        };
      } else {
        acceptsVal = {
          is_active: true,
        };
      }

      axios
        .put(
          `${process.env.VUE_APP_API}/profile/is-active/${item.user_id}/?Key=${this.userInfo.token_key}`,
          acceptsVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        })
        .catch((error) => {
          this.messages = {
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.departmentget();
      }, 3000);
    },
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    async departmentget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-user-details-get/${this.depart_id}/?Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.perPage);
            console.log("  this.department123", this.departments);
          }
        });
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-user-details-get/${this.depart_id}/?search=${this.searching}&Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.perPage);
            console.log("  this.department123", this.departments);
          }
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.departmentget();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.departmentget();
      }
    },
    changePage(page) {
      if (page !== "..." && page !== this.currentPage) {
        this.currentPage = page;
        this.departmentget();
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
